import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { CourseContent, ModalWrapper, DashList } from './Subject.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import { FlexRow, Img, Td } from '../StudentDetails.styled';
import fixedNumber from '@utils/fixedNumber';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import { ButtonRow, ModalContent2 } from '../CourseModal/CourseModal.styled';
import Modal from '@components/Buttons/Modal';
import { useDetectClickOutside } from 'react-detect-click-outside';
import StudentThumbnail from '@components/StudentThumbnail';
import { ModalBackground } from '@components/Buttons/Modal/Modal.styled';

interface IProps { student: any, subjectCount: number, subjectList:any, studentId:any, username:string, displayname: string, courseCount: number }

export const Course = (props: IProps) => {
  const [openStudent, setOpenStudent] = useState(null)
  const { client, filterDate, systemSettings, settings } = useStore();
  const i18n = useI18n();
  const id = useRef(null)  
  let s3 = systemSettings?.find(s => s.APP_Setting_ID === 78)
  const ClickOutside = () => {
    setOpenStudent(false);
  };
  const ref = useDetectClickOutside({ onTriggered: ClickOutside });

  const getStudentData = () => {
    let student = props.student.filter(s => s.student_id === props.studentId)
    let d = student.map(s => {
      console.log(props.subjectList, s)
      let subject = props.subjectList.find(c => c.subject_description === s.subject_name)
      
      return <tr>
        <td>{subject?.subject_description}</td>
        <td>{ fixedNumber(settings.SHOWPRESENCE ? (100 - s.percentage) : s.percentage)}%</td>
      </tr>
    })
    return d
  }

  return (<>{props.subjectCount > 0 && props.courseCount == 0?<td ref={ref} className={"p-right " + (props.subjectCount > 1?"mHover":"")}>
    {openStudent ? <ModalWrapper>
      <ModalContent2>
        <DashList>
          <tbody>
          <tr>              
              <td className={"imgWidth"}><Img><StudentThumbnail font={"1em"} name={props?.displayname} src={props.username} /></Img></td>
              <Td className={"width50"}>{props.displayname}</Td>              
            </tr>
          </tbody>
        </DashList>      
        <DashList>
          <tbody>          
          <tr>              
              <Td className={"width50"}>{i18n.t("registration-course")}</Td>
              <Td className={"right"}>{i18n.t(settings.SHOWPRESENCE ? "header-subject-attendance" : "header-subject-absence")}</Td>              
            </tr>
            {getStudentData()}
          </tbody>
        </DashList>
        <ButtonRow>
          <button onClick={() => setOpenStudent(false)}>{i18n.t("close")}</button>
        </ButtonRow>
      </ModalContent2>
    </ModalWrapper> : null}

    {
      props.student === null?<FlexRow className='p-right'>-</FlexRow>:props.subjectCount === 1 ? props.student && props.student.length > 0 ? <FlexRow className='p-right'>{fixedNumber(settings.SHOWPRESENCE ? (100 - props.student[0].percentage) : props.student[0].percentage)}%</FlexRow> : <FlexRow className='p-right'>-</FlexRow> : props.subjectCount > 1 ? <FlexRow onClick={() => setOpenStudent(true)}>{i18n.t('show')}</FlexRow> : null
    }</td>:null}
  </>);
};

export default Course;
